<template>
  <el-cascader
    placeholder="請選擇年月"
    v-model="dateLocal"
    expand-trigger="click"
    :disabled="loading"
    :options="dateRange"
    @change="beforeSelectDate">
  </el-cascader>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import moment from 'moment'

export default {
  props: {
    level: {
      type: String,
      required: true
    }
  },
  data() {
    if(moment().format('D')>20){
	return {
	dateLocal: [],
	currentYear: moment().add(1,'M').format('YYYY'),
	currentMonth: moment().add(1,'M').format('M')
	}
    }
    else {
        return {
	dateLocal: [],
	currentYear: moment().format('YYYY'),
	currentMonth: moment().format('M')
	}
    }
  },
  computed: {
    ...mapGetters({
      params: 'download/params',
      dateRange: 'download/dateRange',
      loading: 'loading/loading'
    })
  },
  methods: {
    ...mapActions({
      selectLevel: 'download/selectLevel',
      fetchDate: 'download/fetchDate',
      selectDate: 'download/selectDate',
      fetchResources: 'download/fetchResources',
      notify: 'notification/notify'
    }),
    ...mapMutations({
      setDate: 'download/setDate'
    }),
    beforeSelectDate(value) {
      this.selectDate({
        year: value[0],
        month: value[1]
      })
    },
    async init () {
      //await this.setDate()
      await this.selectLevel({ level: this.level })

      try {
        await this.fetchDate()
        this.dateLocal = [this.currentYear, this.currentMonth]
        await this.selectDate({
          year: this.currentYear,
          month: this.currentMonth
        })
      } catch (error) {
        this.notify({ error: error, context: this })
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
